import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuService} from "../../services/menu-service";
import {Subscription} from "rxjs/internal/Subscription";

@Component({
    selector: 'app-saving-page',
    templateUrl: './saving-page.component.html',
    styleUrls: ['./saving-page.component.css'],
    standalone: false
})
export class SavingPageComponent implements OnInit, OnDestroy {

  private savingSub: Subscription | undefined;
  protected savingInProgressScreen: boolean = false;

  constructor(private menuService: MenuService) {
  }

  ngOnInit() {
    this.savingSub = this.menuService.savingStatusChanged.subscribe((status: boolean) => {
      this.savingInProgressScreen = status;
      if (status) {
        // dal momento che e' diventato vero, mostro la pagina che e' condizionata dal loadingInProgressScreen
        // console.log('LoadingPageComponent: visualizzazione della pagina attivata');
      } else {
        // la visualizzazione dello splash screen e' gestita direttamente nel componente SavingPageComponent
        // console.log('LoadingPageComponent: visulizzazione della pagina disattivata');
      }
    });
  }

  ngOnDestroy() {
    if (this.savingSub) {
      this.savingSub.unsubscribe();
    }
  }

}
